import { render, staticRenderFns } from "./EntranceHistoryTemplate.vue?vue&type=template&id=ebd68caa"
import script from "./EntranceHistoryTemplate.vue?vue&type=script&lang=ts"
export * from "./EntranceHistoryTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebd68caa')) {
      api.createRecord('ebd68caa', component.options)
    } else {
      api.reload('ebd68caa', component.options)
    }
    module.hot.accept("./EntranceHistoryTemplate.vue?vue&type=template&id=ebd68caa", function () {
      api.rerender('ebd68caa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/EntranceHistoryTemplate/EntranceHistoryTemplate.vue"
export default component.exports